import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { appConfig } from '../../legacy/lib/config/app-config';
import LinkButton from '../../legacy/ui/button/link-button.vue';
import { useI18N } from '../../legacy/lib/use-i18n';
import { toMailto } from '../../legacy/lib/util/mailto-helper';


export default /*@__PURE__*/_defineComponent({
  __name: 'ask-link',
  props: {
    color: {},
    size: {},
    mailSubject: {},
    mailBody: {}
  },
  setup(__props: any) {


const i18n = useI18N();
const mailto = toMailto(appConfig.get('supportEmail'), {
  subject: __props.mailSubject,
  body: __props.mailBody
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LinkButton, {
    "data-qa": "ask-plug-button",
    color: __props.color,
    type: "link",
    to: _unref(mailto),
    size: __props.size
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(i18n)('ask')), 1)
    ]),
    _: 1
  }, 8, ["color", "to", "size"]))
}
}

})